export default __webpack_public_path__ + "static/media/unit-result-1.60d85717.mp3";